<template>
  <q-select
    v-model.trim="selectedDate"
    v-bind="$attrs"
    @click="showCalendar = true"
  >
    <template #selected-item="scope">
      {{ selectedDatesString (scope) }}
    </template>
    <template #append>
      <q-icon
        name="event"
        class="cursor-pointer"
      >
        <q-popup-proxy
          v-model="showCalendar"
          transition-show="scale"
          transition-hide="scale"
        >
          <q-date
            v-model="selectedDate"
            mask="YYYY-MM-DD"
            :options="formattedDatesWithShowing"
            @update:model-value="handleDateChange"
          />
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-select>
</template>

<script>

export default {
  name: 'ActivityDateSelector',
  components: {
  },
  configuration: ['currentSite'],
  props: {
    activityId: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    initialDate: {
      type: String,
      default: null
    },
    showAllOption: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select-date'],
  data () {
    const initialDateFormatted = this.initialDate?.replace(/\//g, '-')
    return {
      today: this.currentSite.businessDate,
      tomorrow: this.currentSite.businessTomorrow,
      selectedDate: initialDateFormatted
    }
  },
  computed: {
    formattedDatesWithShowing () {
      return this.datesWithActivities.value?.map(date => date.replace(/-/g, '/')) || []
    }
  },
  watch: {
    initialDate: {
      handler (newDate) {
        this.selectedDate = newDate?.replace(/\//g, '-')
      },
      immediate: true
    },
    selectedDate: {
      handler (newDate) {
        this.$emit('select-date', newDate)
      },
      immediate: true
    },
    formattedDatesWithShowing: {
      handler (availableDates) {
        // If no date is selected and we have available dates, select the first one
        if (!this.selectedDate && !_.isEmpty(availableDates)) {
          this.selectedDate = availableDates[0]
        } else if (this.selectedDate && !_.isEmpty(availableDates)) {
          // If the current selected date is not in available dates, select the first available
          const selectedDateFormatted = this.selectedDate.replace(/-/g, '/')
          if (!availableDates.includes(selectedDateFormatted)) {
            this.selectedDate = availableDates[0]
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    handleDateChange (newDate) {
      this.selectedDate = newDate
      this.showCalendar = false
      this.$emit('select-date', newDate)
    },
    selectedDatesString (scope) {
      if (scope.opt === this.today) {
        return `${this.$t('time.today')} ${this.$i18n.d(scope.opt, 'mediumDate')}`
      } else if (scope.opt === this.tomorrow) {
        return `${this.$t('time.tomorrow')} ${this.$i18n.d(scope.opt, 'mediumDate')}`
      } else {
        return `${this.$i18n.d(scope.opt, 'mediumDate')}`
      }
    }
  },
  models: {
    datesWithActivities: {
      variables () {
        return {
          activity_id: this.activityId
        }
      },
      immediate: true,
      force: true
    }
  }
}
</script>
